var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 10.535a6.367 6.367 0 00.535-2.56C16.905 4.124 13.452 1 9.195 1c-4.26 0-7.711 3.123-7.711 6.976 0 2.177 1.103 4.122 2.83 5.402l-.641 4.108 3.875-2.694c.973.191 1.97.212 2.95.06",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.378 15.805c0 2.915 2.612 5.279 5.835 5.279a6.45 6.45 0 001.246-.121L20.39 23l-.486-3.11c1.307-.967 2.142-2.44 2.142-4.086 0-2.916-2.612-5.28-5.834-5.28-3.222 0-5.834 2.364-5.834 5.28h-.001z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.347 16.145l1.083 1.154 2.646-2.82",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44 6.221c0-.823.62-1.565 1.47-1.565.389 0 .762.165 1.037.458.276.294.43.692.43 1.107 0 .415-.154.813-.43 1.107a1.424 1.424 0 01-1.038.458v.696M8.91 10.764a.212.212 0 00-.14.067.239.239 0 00-.062.148c0 .108.1.216.201.216",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91 10.764a.21.21 0 01.138.067c.037.04.06.092.063.148a.24.24 0 01-.063.148.212.212 0 01-.139.068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMagazine;